<template>
  <path
    d="M18 4.00024V20.0002H6V4.00024H18ZM18 2.00024H6C4.9 2.00024 4 2.90024 4 4.00024V20.0002C4 21.1002 4.9 22.0002 6 22.0002H18C19.1 22.0002 20 21.1002 20 20.0002V4.00024C20 2.90024 19.1 2.00024 18 2.00024ZM7 19.0002H17V13.0002H7V19.0002ZM10 10.0002H14V11.0002H17V5.00024H7V11.0002H10V10.0002Z"
  />
</template>
